<template>
  <div>
    <modal :show="true">
      <textarea rows="20" cols="120" style="max-width:100%;" disabled v-model="newsText"/>
      <template slot="footer">
        <base-button type="primary" @click="closeDialog()">{{ $t('close')  }}</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  props: ["news"],
  computed: {
    newsText() {
      let newsHtml = "";
      this.news.forEach(newsItem => {
        newsHtml += newsItem.news_date.split("T")[0] + "\n"
        newsHtml += newsItem.new_features
        newsHtml += "\n\n"
      });
      return newsHtml;
    }
  },
  methods: {
    closeDialog() {
      this.$bus.$emit('close-news-dialog');
    }    
  }
};
</script>

<i18n>
{
  "en": {
    "close": "Close"
  },
  "fi": {
    "close": "Sulje"
  },
 "sv": {
    "close": "Stäng"
  },
 "de": {
    "close": "Schließen"
  },
  "ko": {
    "close": "닫기"
  }
}
</i18n>
